import {
  LEGACY_KEYS,
  LEGACY_MIGRATION_MARKER,
  LEGACY_MIGRATION_VERSION,
  LEGACY_SHARED_KEYS,
  LEGACY_SUFFIXED_KEYS,
} from './localStorage.legacy.constants';
import lsKey from '../base/localStorage.key';
import lsLog from '../base/localStorage.log';
import { SHARED_TEAM_SEGMENT } from '../useScopedKeyInput';

const copySharedKeys = (userId: string) => {
  LEGACY_SHARED_KEYS.forEach((legacyKey) => {
    const legacyValue = window.localStorage.getItem(legacyKey);

    if (legacyValue == null) return;

    const scopedKey = lsKey.create([userId, SHARED_TEAM_SEGMENT, legacyKey]);

    if (window.localStorage.getItem(scopedKey) != null) return;

    window.localStorage.setItem(scopedKey, legacyValue);
  });
};

const getSuffixedLegacyKeys = () =>
  Object.keys(window.localStorage).filter((storedKey) =>
    LEGACY_SUFFIXED_KEYS.some((legacyKey) => storedKey.startsWith(legacyKey)),
  );

// TODO: delete after a short while of being live
const migrateLegacyLocalStorage = (userId: string) => {
  try {
    const markerKey = lsKey.create(LEGACY_MIGRATION_MARKER);

    if (window.localStorage.getItem(markerKey) === LEGACY_MIGRATION_VERSION) return;

    copySharedKeys(userId);

    [...LEGACY_SHARED_KEYS, ...LEGACY_KEYS, ...getSuffixedLegacyKeys()].forEach((legacyKey) =>
      window.localStorage.removeItem(legacyKey),
    );

    window.localStorage.setItem(markerKey, LEGACY_MIGRATION_VERSION);
  } catch (err) {
    lsLog.error('LS LEGACY_MIGRATION', err);
  }
};

export default migrateLegacyLocalStorage;
